import tw from 'twin.macro'
import styled from 'styled-components'
import Modal from 'styled-react-modal'

export const SliderModal = Modal.styled`
  width: calc(100% - 7rem);
  height: calc(100% - 7rem);
  ${tw`relative overflow-visible`}

  @media (max-width: 991px) {
    width: calc(100% - 3rem);
    height: 50vh;
  }

  @media (orientation: landscape) {
    height: 80vh;
  }
`

export const SliderWrap = styled.div`
  ${tw`relative h-full`}
`

export const Close = styled.div`
  ${tw`absolute z-50 flex items-center justify-center w-10 h-10 bg-black text-white text-2xl rounded-full cursor-pointer`}
  top: -1.5rem;
  right: -1.5rem;
  line-height: 1;

  @media (max-width: 991px) {
    top: -2.75rem;
    right: 0;
  }
`

export const CarouselItem = styled.div`
  height: calc(100vh - 7rem);

  ${tw`bg-black`}

  > img {
    ${tw`h-full w-auto!`}
  }

  @media (max-width: 991px) {
    height: 50vh;
  
    > img {
      ${tw`object-cover`}
    }
  }

  @media (orientation: landscape) {
    height: 80vh;
  }

  > div {
    ${tw`h-full pt-0 bg-black`}
  }

  iframe {
    ${tw`w-full! h-full! m-0! border-0!`}
  }
`
